<template>
  <div id="task">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'task'
}
</script>




// WEBPACK FOOTER //
// src/views/process/task/Task.vue